import React, { Component } from "react";
import * as FlexLayout from "flexlayout-react";
import Roles from "./roles";
import Role from "./role";
import { withTranslation } from "react-i18next";

class RoleAdmin extends Component {
  LAYOUT = {
    global: {
      minWidth: 100,
      minHeight: 100,
    },
    borders: [],
    layout: {
      type: "row",
      children: [
        {
          type: "tabset",
          weight: 50,
          enableMaximize: false,
          children: [
            {
              type: "tab",
              name: this.props.t("Roles"),
              enableClose: false,
              component: "Roles",
            },
          ],
        },
        {
          //Figure out how to make this persistent even when empty.
          type: "tabset",
          id: "1",
          weight: 50,
          enableDeleteWhenEmpty: false,
          enableMaximize: false,
          children: [
            // {
            //   type: "tab",
            //   name: "User",
            //   visible: false,
            //   component: "Placeholder"
            // }
          ],
        },
      ],
    },
  };

  state = {
    model: FlexLayout.Model.fromJson(this.LAYOUT),
  };

  handleRoleSelect = (Role, submitCallbackFunction, isNew) => {
    const { roleId, name } = Role;

    try {
      this.state.model.doAction(
        FlexLayout.Actions.addNode(
          {
            type: "tab",
            component: "Role",
            name: `${name}`,
            id: `${roleId}`,
            config: { roleId, submitCallbackFunction, isNew },
          },
          "1",
          FlexLayout.DockLocation.CENTER,
          0,
          true
        )
      );
    } catch {
      this.state.model.doAction(FlexLayout.Actions.selectTab(roleId));
    }
  };

  handleTabRename = (nodeId, name) => {
    this.state.model.doAction(
      FlexLayout.Actions.updateNodeAttributes(nodeId, { name: name })
    );
  };

  factory = (node) => {
    const componentId = node.getComponent();
    //const RoleId = node.getId();

    if (componentId === "Roles") {
      return (
        <Roles
          onClick={this.handleRoleSelect}
          allowEdit={this.props.allowEdit}
        />
      );
    } else if (componentId === "Role") {
      const { roleId, submitCallbackFunction, isNew } = node.getConfig();
      return (
        <Role
          roleId={roleId}
          submitCallbackFunction={submitCallbackFunction}
          isNew={isNew}
          onRename={this.handleTabRename}
          allowEdit={this.props.allowEdit}
        />
      );
    } else if (componentId === "Placeholder") {
      return <div></div>;
    } else {
      return null;
    }
  };

  buildFlexLayout = () => {
    return (
      <div className="flex-container auth-container">
        <FlexLayout.Layout model={this.state.model} factory={this.factory} />
      </div>
    );
  };

  render() {
    return this.buildFlexLayout();
  }
}

export default withTranslation(["auth"])(RoleAdmin);
